import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ErrorService } from '../../../../services/error.service';
import { ProgramService } from '../../../../services/api/program.service';
import { FavoritesSyncService } from '../../../../services/favorites-sync.service';

@Component({
    selector: 'app-favourite',
    templateUrl: './favourite.component.html',
    styleUrl: './favourite.component.scss',
})
export class FavouriteComponent implements OnInit {
    @Input() isFavourite = false;
    @Input() programId = '';
    @Input() uiType: FavouriteUIType = FavouriteUIType.ProgramCard;
    @Output() favourite: EventEmitter<void> = new EventEmitter();

    protected uiClass = '';

    constructor(
        private errorService: ErrorService,
        private programService: ProgramService,
        private favoritesSyncService: FavoritesSyncService,
    ) {}

    ngOnInit(): void {
        this.initUiClass();
    }

    protected onBookmarkClick(webinarId: string, isFavourite: boolean): void {
        const newFavoriteStatus = !isFavourite;
        
        this.programService.bookmarkProgram(webinarId, newFavoriteStatus).subscribe({
            next: () => {
                // Emit to parent component (for local UI update)
                this.favourite.emit();
                
                // Emit to sync service (for cross-component synchronization)
                this.favoritesSyncService.emitFavoriteChange(webinarId, newFavoriteStatus);
            },
            error: (error) => {
                this.errorService.showError(error);
            },
        });
    }

    private initUiClass(): void {
        switch (this.uiType) {
            case FavouriteUIType.WebinarScheduleCard:
                this.uiClass = 'webinar-schedule-card';
                break;
            case FavouriteUIType.ProgramCard:
                this.uiClass = 'program-card';
                break;
        }
    }
}

enum FavouriteUIType {
    WebinarScheduleCard,
    ProgramCard,
}
